import renameKeyOfObjectOrSetValue from "../renameKeyOfObjectOrSetValue";
// Transform block tree state redirection to block server api
const BlockActionRedirectionTransformer = (origin) => {

    const data = { ...origin };

    renameKeyOfObjectOrSetValue(data, { old_key : 'variable', new_key : 'keyword_var' }, data.variable ? data.variable.name : null)
    renameKeyOfObjectOrSetValue(data, { old_key : 'variable_redirect', new_key : 'keyword_redirect_var' }, data.variable_redirect ? data.variable_redirect.name : null)
    
    return data
}

export default BlockActionRedirectionTransformer;
